import useLoginUser from "hooks/useLoginUser";
import Logout from "./Logout";
import Signup from "./Signup";
import Login from "./Login";
import Coupon from "./Coupon";

const SideMenu = () => {
    const { user, isLoading } = useLoginUser();

    return isLoading ? (
        <></>
    ) : (
        // return (
        <ul>
            {user ? (
                <>
                    <Logout />
                    <Coupon />
                </>
            ) : (
                <>
                    <Login />
                    <Signup />
                </>
            )}
        </ul>
    );
    // );
};

export default SideMenu;
